import React, { useMemo } from 'react';
import { BaseNewAndDetail, getDarkThemeClass } from '../../utility';
import { useTheme } from '@emotion/react';
import { useNavigate, useParams } from 'react-router-dom';
import { FeedbackContext } from '../../../App';
import LabTestBatchesTab from './_LabTestBatchesTab';
import LabTestTypesTab from './_LabTestTypesTab';
import LabTestStatesTab from './_LabTestStatesTab';
import { ItemBreadCrumbs } from '../../utility/BreadcrumbLinks';

export default function LabTests(props) {
  const theme = useTheme();
  const feedbackCX = React.useContext(FeedbackContext);
  const { labtest } = useParams();

  const currentTab = labtest || 'Lab Tests';
  const currDarkThemeClass = useMemo(() => getDarkThemeClass(theme), [theme]);
  const baseEntityName = 'Lab Tests';
  const batchesTagKey = 'batches';
  const typesTagKey = 'types';
  const statesTagKey = 'states';

  const tabEntityMap = [
    { key: batchesTagKey, label: 'Batches', defaultForDetail: true, validForNew: false },
    { key: typesTagKey, label: 'Lab Test Types', defaultForDetail: false, validForNew: false },
    { key: statesTagKey, label: 'Lab Test States', defaultForDetail: false, validForNew: false },
  ];

  const navigate = useNavigate();
  const breadcrumbsProps = { currLink: currentTab, currDarkThemeClass, navigate };
  const breadcrumbs = <ItemBreadCrumbs {...breadcrumbsProps} />;

  const tabContentMap = {
    [batchesTagKey]: <LabTestBatchesTab currDarkThemeClass={currDarkThemeClass} feedbackCX={feedbackCX} />,
    [typesTagKey]: <LabTestTypesTab currDarkThemeClass={currDarkThemeClass} feedbackCX={feedbackCX} />,
    [statesTagKey]: <LabTestStatesTab currDarkThemeClass={currDarkThemeClass} feedbackCX={feedbackCX} />,
  };

  const defShowSaveBtn = () => false;

  const baseProps = {
    baseEntityName,
    baseid: undefined,
    currDarkThemeClass,
    tabContentMap,
    tabEntityMap,
    breadcrumbs,
    createBaseEntityMsg: '',
    baseEndpointCheck: false,
    enablePopup: true,
    showSaveBtn: defShowSaveBtn,
    toDisable: () => false,
    handleSave: () => {},
    getDefaultTabForEndpoint: () => tabEntityMap?.find(tab => tab?.defaultForDetail)?.key,
  };

  return <BaseNewAndDetail {...baseProps} />;
}